export const CURRENT_PAGE = '::current';
export const TURBO_LIVE_ROOT_PATH = '/live-stavky';
export const TURBO_LIVE_FAVORITE_PATH = `${TURBO_LIVE_ROOT_PATH}/favorites`;
export const TURBO_LIVE_SPORT_PATH = `${TURBO_LIVE_ROOT_PATH}/:sportName?`;
export const TURBO_LIVE_MATCH_DETAIL_PATH = `${TURBO_LIVE_ROOT_PATH}/:sportName/:matchId`;
export const N1_ROOT_PATH = '/tipovanie';
export const N1_MATCH_DETAIL = `${N1_ROOT_PATH}/zapas/:eventId/:meta?`;

export const TV_NIKE_STREAM_DETAIL_PATH = '/niketv/stream/:streamId/:niceUrl?';
export const TV_NIKE_STREAM_OVERVIEW_PATH = '/niketv/:sportSlugPart?';

export const TV_NIKE_ARCHIVE_DETAIL_PATH = '/archiv/stream/:streamId/:meta?';
export const TV_NIKE_ARCHIVE_OVERVIEW_PATH = '/archiv/:sportSlugPart?';

export const TV_NIKE_HIGHLIGHTS_DETAIL_PATH = '/highlighty/stream/:streamId/:meta?';
export const TV_NIKE_HIGHLIGHTS_OVERVIEW_PATH = '/highlighty/:sportSlugPart?';

export const BETBOOK_NEW_POST = 'komunita/analyzy/nova';
export const NIKE_ONE_OVERVIEW_PATH = '/tipovanie/:sportName?';
export const NIKE_ONE_RESULTS_PATH = '/vysledky/:sportName?';
